(function() {
    'use strict';

    angular
        .module('app')
        .controller('myTrainingOrganizerModalController', myTrainingOrganizerModalController);

    function myTrainingOrganizerModalController($scope, $rootScope, $uibModalInstance, params, choiceList, modalService) {
        var vm = this;
        vm.send = send;
        vm.checkboxClick = checkboxClick;
        vm.searchResultEnd = searchResultEnd;
        vm.searchData = searchData;
        vm.cancel = cancel;
        vm.isApp = false;
        onInit();

        function dataInit() {
            vm.data = {
                checkedList: choiceList || [],
                sourceData: params || [],
                listData: [], //.....................主辦單位清單
            };
            vm.view = {
                // showOther: false,
                emptyParams: false, //..........尚未輸入收尋條件
                buttonShow: false, //...........確定按鈕是否出現(包含浮動)
                staticButtonShow: false, //.....確定按鈕是否出現(固定按鈕)
                orgSearchEmpty: false, //.......主辦單位清單為空
            };
        }

        function logicInit() {
            vm.search = '';
            _.forEach(vm.data.sourceData, function(item) {
                item.checked = (_.findIndex(vm.data.checkedList, { "id": item.id }) > -1);
                item.CheckValue = item.checked;
            });
            // searchData();
        }

        function onInit() {
            if (DEVICE_TOKEN !== null || DEVICE_TYPE !== null) {
                //console.log('isApp:', vm.isApp);
                vm.isApp = true;
            }
            dataInit();
            logicInit();
            Jquery();
        }

        function send() {
            var result = [];
            _.forEach(vm.data.listData, function(item) {
                if (item.Check) { result.push(item); }
            });
            $uibModalInstance.close(result);
        }

        function searchData() {
            $(document).trigger('submitSearchStart', {});
            vm.view.buttonShow = false;
            vm.view.emptyParams = false;
            vm.data.listData = [];
            // =====
            vm.search = vm.search || '';
            if (vm.search.length < 1) {
                vm.view.emptyParams = true;
                toastr.warning($rootScope.translate.tsunFormMsgRequiredEmpty);
                return;
            }
            // =====
            if (vm.search) {
                var regExpCompare = new RegExp(vm.search, "g");
                _.forEach(vm.data.sourceData, function(item) {
                    if (item.name.match(regExpCompare)) {
                        vm.data.listData.push(angular.copy(item));
                    }
                });
                vm.view.orgSearchEmpty = (vm.data.listData.length < 1);
            } else {
                vm.data.listData = angular.copy(vm.data.sourceData);
            }
            // vm.data.listData.push({ id: 0, name: $rootScope.translate.tsunOther });
        }

        function checkboxClick(item) {
            if (item.checked) { return; }
            var itemChecked = !item.Check;
            item.Check = itemChecked;
            item.CheckValue = itemChecked;
            checkHasClick();
        }

        function checkHasClick() {
            var checkedItemIndex = _.findIndex(vm.data.listData, { Check: true });
            vm.view.buttonShow = (checkedItemIndex > -1);
            // console.log("call checkboxClick , trigger:", vm.view.buttonShow);
            $(document).trigger('checkboxClick', [vm.view.buttonShow]);
        }

        function searchResultEnd() {
            $(document).trigger('submitSearchEnd', {});
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
        //======Jquery
        function Jquery() {
            $(document)
                .off('floatButtonDisplay')
                .on('floatButtonDisplay', function(event, triggerResult) {
                    var staticButtonShow = (!triggerResult);
                    if (vm.view.staticButtonShow !== staticButtonShow) {
                        vm.view.staticButtonShow = staticButtonShow;
                        if (!$scope.$$phase) {
                            $scope.$digest();
                        }
                    }
                });
        }
    }
})();